import { render, staticRenderFns } from "./projectmanagement.vue?vue&type=template&id=5bb7b2e8&scoped=true&"
import script from "./projectmanagement.vue?vue&type=script&lang=js&"
export * from "./projectmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb7b2e8",
  null
  
)

export default component.exports